import { DateTime } from 'luxon';
import { accountStatus } from 'shared/constants.json';

const contractStartThreshold = { months: 1 };
const userActivatedAtThreshold = { months: 1 };
const userSessionsThreshold = 4;
const feedbackLastAskedThreshold = { months: 3 };
const feedbackLastAnsweredThreshold = { months: 6 };

const nullDate = DateTime.local(2020);
const toDateTime = (iso) => (iso ? DateTime.fromISO(iso) : nullDate);

// feedbackHistory holds the identity-wide cooldown timestamps resolved by sentinel
// /me ({ lastAskedAt, lastAnsweredAt }), so the cooldown holds across accounts
// rather than being derived from the current account's feedback only.
export const canDisplayAppFeedback = (account, user, feedbackHistory, t = DateTime.local().toISO()) => {
  const now = DateTime.fromISO(t);
  if (account.accountSettings.status !== accountStatus.active) {
    return false;
  }
  if (DateTime.fromISO(account.accountSettings.expiresAt) < now) {
    return false;
  }
  if (account.customerContract.startedAt === undefined) {
    return false;
  }
  if (!account.accountSettings.receivesInAppFeedback) {
    return false;
  }
  if (DateTime.fromISO(account.customerContract.startedAt) > now.minus(contractStartThreshold)) {
    return false;
  }
  if (DateTime.fromISO(user.activatedAt) > now.minus(userActivatedAtThreshold)) {
    return false;
  }
  if (user.identity.sessionCount < userSessionsThreshold) {
    return false;
  }

  const lastAskedTimestamp = toDateTime(feedbackHistory?.lastAskedAt);
  const lastAnsweredTimestamp = toDateTime(feedbackHistory?.lastAnsweredAt);

  if (lastAskedTimestamp > now.minus(feedbackLastAskedThreshold)) {
    return false;
  }
  if (lastAnsweredTimestamp < now.minus(feedbackLastAnsweredThreshold)) {
    return true;
  }
  return false;
};
